import { SITE_STATS } from '@/data/siteData'
import styles from './StatsBand.module.css'

export default function StatsBand() {
  return (
    <div className={styles.band} aria-label="Platform statistics">
      <div className={styles.grid}>
        {SITE_STATS.map(({ val, label }) => (
          <div key={label} className={styles.item}>
            <p className={styles.val}>{val}</p>
            <p className={styles.label}>{label}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
